<template>
  <div class="login-fondo login-fondo-responsive d-flex align-center justify-center">
    <v-container fluid class="pa-0 ma-0 fill-height">
      <v-row class="d-flex justify-center align-center fill-height" style="min-height:100vh;">
        <v-col xs="12" sm="8" md="6" class="d-flex flex-column align-center pa-0 ma-0">
          <!-- Banner BIENVENIDO estilo Nova -->
          <div class="bienvenido-nova">
            BIENVENIDO
          </div>

          <!-- Card centrada -->
          <v-card class="elevation-12 my-4 login-card-responsive">
            <v-toolbar dark color="#294697" height="200" class="login-header">
              <v-img
                :src="require('../assets/nova/Logo_nova.png')"
                aspect-ratio="1.5"
                contain
              ></v-img>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                color="#294697"
                class="mt-6"
                prepend-icon="mdi-account"
                label="Cedula"
                type="number"
                v-model="cedula"
                autofocus
                autocomplete="off"
                v-on:keyup.enter="validarCedula()"
                :disabled="loadingSesion || cedulaValidada"
              ></v-text-field>
              <v-btn
                v-if="!cedulaValidada"
                class="mt-2"
                block
                style="color: whitesmoke"
                color="#294697"
                @click="validarCedula()"
                rounded
                :loading="loadingSesion"
                :disabled="loadingSesion || !cedula"
              >
                Continuar
              </v-btn>
              <v-text-field
                v-if="cedulaValidada"
                color="#294697"
                prepend-icon="mdi-lock"
                label="Contraseña"
                type="password"
                v-model="contrasena"
                v-on:keyup.enter="IniciarSesion()"
              ></v-text-field>
              <v-btn
                v-if="cedulaValidada"
                class="mt-6"
                block
                style="color: whitesmoke"
                color="#294697"
                @click="IniciarSesion()"
                rounded
                :loading="loadingSesion"
                :disabled="loadingSesion"
              >
                Iniciar Sesión
                <template v-slot:loader>
                  Iniciando Sesión
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>
            </v-card-text>
          </v-card>

            <div class="d-flex justify-center msj2 w-100">
              <div class="logos-banner w-100 d-flex justify-center align-center">
                <img 
                  src="../assets/LOGO-FACILISIMO-GRIS.png" 
                  alt="Facilisimo" 
                  class="logo-facilisimo" 
                />
                <div class="separador-logos"></div>
                <img 
                  src="../assets/nova/LOGO APOSTAR-06.png" 
                  alt="Apostar A tu lado" 
                  class="logo-apostar" 
                />
              </div>
            </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      top
      multi-line
      class="snackbar"
      color="#294697"
      border="left"
    >
      <span>
        <h3>{{ text }}</h3></span
      >
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>      </template>
    </v-snackbar>

    <!-- Modal para cambio de contraseña obligatorio -->
    <v-dialog v-model="dialogCambioContrasena" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline white--text" style="background-color: #1D3C7F;">
          <v-icon color="white" class="mr-2">mdi-lock-reset</v-icon>
          Cambio de Contraseña Obligatorio
        </v-card-title>
        <v-card-text class="pa-6">
          <v-alert type="info" outlined class="mb-4">
            Es su primer ingreso al sistema. Debe cambiar su contraseña para continuar.
          </v-alert>
          <v-form ref="formCambioContrasena" v-model="validFormContrasena">
            <v-text-field
              color="#294697"
              prepend-icon="mdi-lock"
              label="Nueva Contraseña"
              type="password"
              v-model="nuevaContrasena"
              :rules="contrasenaRules"
              required
              autocomplete="new-password"
            ></v-text-field>
            <v-text-field
              color="#1D3C7F"
              prepend-icon="mdi-lock-check"
              label="Confirmar Nueva Contraseña"
              type="password"
              v-model="confirmarContrasena"
              :rules="confirmarContrasenaRules"
              required
              autocomplete="new-password"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="#1D3C7F" 
            style="color: white"
            @click="cambiarContrasena"
            :loading="loadingCambioContrasena"
            :disabled="!validFormContrasena || loadingCambioContrasena"
          >
            Cambiar Contraseña
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import env from "./env";
export default {
  data: () => ({
    cedula: "",
    contrasena: "",
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 4000,
    text: "",
    loadingSesion: false,
    cedulaValidada: false,
    
    // Variables para cambio de contraseña
    dialogCambioContrasena: false,
    nuevaContrasena: "",
    confirmarContrasena: "",    validFormContrasena: false,
    loadingCambioContrasena: false,
    usuarioTemporal: null,
    
    // Reglas de validación
    contrasenaRules: [
      v => !!v || 'La contraseña es requerida',
      v => (v && v.length >= 6) || 'La contraseña debe tener al menos 6 caracteres',
      v => v !== localStorage.getItem("cedula") || 'La contraseña no puede ser igual a su cédula',
    ],
  }),
  computed: {
    confirmarContrasenaRules() {
      return [
        v => !!v || 'Debe confirmar la contraseña',
        v => v === this.nuevaContrasena || 'Las contraseñas no coinciden'
      ];
    }
  },
  mounted() {
    localStorage.clear();
  },
  methods: {
    /**
     * Metodo para validar cedula
     */
    validarCedula() {
      if (!this.cedula) {
        this.text = "Por favor ingrese la cédula";
        this.snackbar = true;
        return;
      }
      this.loadingSesion = true;
      axios
        .get(`${env.endpoint}user/validarCedula?cedula=${this.cedula}`)
        .then((res) => {
          if (res.data && res.data.existe) {
            this.cedulaValidada = true;
            this.text = "Cédula validada, ingrese su contraseña.";
            this.snackbar = true;
          } else {
            this.text = "La cédula no está registrada en la plataforma.";
            this.snackbar = true;
            this.cedulaValidada = false;
          }
          this.loadingSesion = false;
        })
        .catch(() => {
          this.text =
            "Ha ocurrido un problema con el servidor, vuelva a intentar, si el problema persiste comuníquese con el área de sistemas.";
          this.snackbar = true;
          this.loadingSesion = false;
        });
    },
    /**
     * Metodo para iniciar sesion
     */
    IniciarSesion() {
      if (!this.cedulaValidada) return;
      this.loadingSesion = true;
      axios
        .get(
          `${env.endpoint}user/iniciar?cedula=${this.cedula}&pass=${this.contrasena}`
        )
        .then((res) => {          
          // console.log("res.data", res.data)
          if (res.data.mensaje === "inicio correcto") {
            // PRIMERO: Completar login normal y guardar credenciales
            this.completarLogin(res.data.user);
            
            // DESPUÉS: Verificar si necesita cambiar contraseña
            if (parseInt(res.data.user.primer_ingreso) === 1) {
              this.usuarioTemporal = res.data.user;
              this.dialogCambioContrasena = true;
              return; // Evitar navegación hasta cambiar contraseña
            }
          }else if (res.data.mensaje === "faltan parametros") {
            this.text = "Por favor ingresar todos los datos";
            this.snackbar = true;
          } else if (res.data.mensaje === "usuario no registrado") {
            this.text = "El usuario no esta registrado en la plataforma";
            this.snackbar = true;
          } else if (res.data.mensaje === "usuario inactivo") {
            this.text = "El usuario se encuentra inactivo en el sistema";
            this.snackbar = true;
          } else {
            this.text = "Contraseña incorrecta";
            this.snackbar = true;
          }
          this.loadingSesion = false;
        })
        .catch((e) => {
          this.text =
            "Ha ocurrido un problema con el servidor, vuelva a intentar, si el problema persiste comuniquese con el area de sistemas.";
          this.snackbar = true;          this.loadingSesion = false;
        });
    },

    /**
     * Método para cambiar la contraseña en el primer ingreso
     */    cambiarContrasena() {
      if (!this.$refs.formCambioContrasena.validate()) {
        return;
      }
      
      this.loadingCambioContrasena = true;
      
      axios.post(`${env.endpoint}User/cambiar_contrasena`, {
        idUsuario: localStorage.getItem("id"), // Obtener del localStorage
        contrasenaNueva: this.nuevaContrasena // Cambiar nombre del parámetro
      })
      .then((res) => {
        if (res.data.estado) {
          this.text = "Contraseña cambiada exitosamente";
          this.snackbar = true;
          
          // Cerrar modal y navegar
          this.dialogCambioContrasena = false;
          this.navegarSegunRol(this.usuarioTemporal.rol);
          
          // Limpiar campos
          this.limpiarCamposContrasena();
        } else {
          this.text = res.data.mensaje || "Error al cambiar la contraseña";
          this.snackbar = true;
        }
        this.loadingCambioContrasena = false;
      })
      .catch((error) => {
        this.text = "Error en el servidor al cambiar la contraseña";
        this.snackbar = true;
        this.loadingCambioContrasena = false;
      });
    },    /**
     * Método para completar el proceso de login
     */
    completarLogin(user) {
      // Guardar credenciales en localStorage
      localStorage.setItem("id", user.id);
      localStorage.setItem("nombre", user.nombre);
      localStorage.setItem("cedula", user.cedula);
      localStorage.setItem("rol", user.rol);
      localStorage.setItem("idCargo", user.idCargo);
      localStorage.setItem("idZona", user.idZona);
      localStorage.setItem("changePassword", user.errorLog);
      localStorage.setItem("idArea", user.idArea);
      localStorage.setItem("idEmpresa", user.idEmpresa);

      for (let i = 0; i < user.permisos.length; i++) {
        if (user.permisos[i].nombreApp === "CALLCENTER") {
          localStorage.setItem("rolCall", user.permisos[i].rol);
        }
        if (user.permisos[i].nombreApp === "ENCUESTA") {
          localStorage.setItem("rolEncuesta", user.permisos[i].rol);
        }
      }

      // Solo navegar si no es primer ingreso
      if (parseInt(user.primer_ingreso) !== 1) {
        this.navegarSegunRol(user.rol);
      }
    },

    /**
     * Método para navegar según el rol del usuario
     */
    navegarSegunRol(rol) {
      if (rol === "USUARIO") {
        localStorage.setItem("homepage", "/user");
        this.$router.push("/user");
      } else if (rol === "ADMINISTRADOR") {
        localStorage.setItem("homepage", "/admin");
        this.$router.push("/admin");
      } else if (rol === "CONFIGURACION") {
        localStorage.setItem("homepage", "/configuracion");
        this.$router.push("/configuracion");
      }
    },

    /**
     * Método para limpiar los campos del formulario de cambio de contraseña
     */
    limpiarCamposContrasena() {
      this.nuevaContrasena = "";
      this.confirmarContrasena = "";
      this.usuarioTemporal = null;
      if (this.$refs.formCambioContrasena) {
        this.$refs.formCambioContrasena.resetValidation();
      }
    },
  },
};
</script>
<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.login-header {
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 76%, 0% 100%);
  clip-path: polygon(0 0, 100% 0, 100% 76%, 0% 100%);

}

.msj1 h1 {
  text-align: center;
  color: #294697;
  margin-bottom: 25px;
  width: 300px;
  padding: 10px;
  border-radius: 50px;
  background: transparent;
}

.msj2 h1 {
  text-align: center;
  color: white;
  width: 550px;
  padding: 10px;
  border: 1px #294697 solid;
  border-radius: 50px;
  background: #294697;
  margin-top: 25px;
}
.container__image--with{
  height: 300px;
}

.login-fondo {
  background-image: url("../assets/PANTALLA-02.jpg");
  background-position: center center !important;
  background-size: cover !important;
  height: 100%;
}

.login-fondo-responsive {
  min-height: 100vh !important;
  min-width: 100vw !important;
  width: 100vw !important;
  max-width: 100vw !important;
  height: 100vh !important;
  overflow-x: hidden !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}

.login-card-responsive {
  width: 370px;
  max-width: 95vw;
}

.CopyRight {
  text-align: center;
  margin-top: -50px;
  font-size: 20px;
  color: white;
  padding: 10px;
  background-color: #000;
  background-color: #294697;
  background-image: linear-gradient(19deg, #294697 0%, #1D3C7F 100%);
}

/* Tablet específico (iPad) - Solo centrado vertical */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .login-fondo-responsive {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .v-container {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 100vh !important;
  }
  .v-row {
    align-items: center !important;
    justify-content: center !important;
    min-height: 100vh !important;
  }
  .v-col {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
  }
}

/* Tablet Portrait específico */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .login-fondo-responsive {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .v-container {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 100vh !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .v-row {
    align-items: center !important;
    justify-content: center !important;
    min-height: 100vh !important;
    width: 100% !important;
    margin: 0 !important;
  }
  .v-col {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
  }
  .login-card-responsive {
    margin: 0 auto !important;
    width: 400px !important;
    max-width: 70vw !important;
    display: block !important;
  }
  .bienvenido-nova {
    width: 100% !important;
    text-align: center !important;
    margin: 0 auto !important;
  }
  .apostar-banner {
    width: 100% !important;
    justify-content: center !important;
    margin: 0 auto !important;
  }
}

@media screen and (max-width: 600px) {
.msj1 h1 {
  font-size:16px;
  text-align: center;
  color: white;
  margin-bottom: 25px;
  width: 200px;
  padding: 7px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(19deg, #294697 0%, #1D3C7F 100%);
}

.msj2 h1 {
  font-size: 16px;
  text-align: center;
  color: white;
  width: 500px;
  padding: 10px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(19deg, #294697 0%, #1D3C7F 100%);
  margin-top: 25px;
}
.container__image--with{
  height: 150px;
}
}

.apostar-banner {
  background: transparent;
  border-radius: 40px;
  padding: 10px 180px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

/* Estilos para el contenedor de logos */
.logos-banner {
  background: transparent;
  border-radius: 40px;
  padding: 10px 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  gap: 20px;
  flex-wrap: wrap;
}

.logo-facilisimo {
  max-width: 300px;
  max-height: 80px;
  height: auto;
  width: auto;
  display: block;
  object-fit: contain;
}

.separador-logos {
  width: 2px;
  height: 80px;
  background: linear-gradient(to bottom, transparent, #294697, transparent);
  margin: 0 15px;
  opacity: 0.6;
  align-self: center;
}

@media (max-width: 768px) {
  .apostar-banner {
    padding: 10px 20px;
  }
  
  .logos-banner {
    padding: 10px 15px;
    gap: 15px;
  }
  
  .logo-facilisimo {
    max-width: 150px;
  }
  
  .separador-logos {
    height: 50px;
    margin: 0 10px;
  }
}

@media (max-width: 480px) {
  .apostar-banner {
    padding: 10px 10px;
  }
  
  .logos-banner {
    padding: 8px 10px;
    gap: 10px;
    flex-direction: column;
  }
  
  .logo-facilisimo {
    max-width: 140px;
    max-height: 40px;
  }
  
  .separador-logos {
    width: 60px;
    height: 2px;
    margin: 5px 0;
    background: linear-gradient(to right, transparent, #294697, transparent);
  }
}

.logo-apostar {
  max-width: 300px;
  max-height: 80px;
  height: auto;
  width: auto;
  display: block;
  object-fit: contain;
}

.bienvenido-nova {
  background: transparent;
  color: #294697;
  font-family: 'Comfortaa', 'Poppins', 'Roboto', sans-serif;
  font-size: 2.5rem;
  font-weight: 990;
  letter-spacing: 6px;
  border-radius: 40px;
  padding: 18px 10px;
  width: 100%;
  max-width: 90vw;
  text-align: center;
  margin: 0 auto;
  box-sizing: border-box;
}
.mt-6 input[type="number"]::-webkit-inner-spin-button,
.mt-6 input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Responsive Login Styles */
@media (max-width: 960px) {
  .login-card-responsive {
    width: 90vw;
    min-width: 0;
    margin: 10px auto;
  }
  .bienvenido-nova {
    font-size: 2rem;
    width: 95vw;
    padding: 15px 10px;
    letter-spacing: 4px;
  }
  .logo-apostar {
    max-width: 220px;
    max-height: 60px;
  }
  .logo-facilisimo {
    max-width: 220px;
    max-height: 60px;
  }
}

@media (max-width: 768px) {
  .login-fondo-responsive {
    background-attachment: scroll;
  }
  .login-card-responsive {
    width: 95vw;
    margin: 10px auto;
  }
  .bienvenido-nova {
    font-size: 1.8rem;
    width: 95vw;
    padding: 12px 10px;
    letter-spacing: 3px;
  }
  .logo-apostar {
    max-width: 180px;
    max-height: 50px;
  }
  .logo-facilisimo {
    max-width: 180px;
    max-height: 50px;
  }
}

@media (max-width: 600px) {
  .login-fondo-responsive {
    min-width: 100vw !important;
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh !important;
    min-height: 100vh !important;
    padding: 0 !important;
    margin: 0 !important;
    background-attachment: scroll;
    overflow-x: hidden !important;
  }
  .login-card-responsive {
    width: 92vw !important;
    max-width: 92vw !important;
    min-width: 0 !important;
    margin: 8px auto !important;
    border-radius: 12px;
    box-sizing: border-box !important;
  }
  .bienvenido-nova {
    font-size: 1.5rem !important;
    width: 100% !important;
    max-width: 95vw !important;
    padding: 10px 5px !important;
    letter-spacing: 2px;
    margin: 0 auto !important;
    box-sizing: border-box !important;
  }
  .logo-apostar {
    max-width: 140px !important;
    max-height: 40px !important;
  }
  .logo-facilisimo {
    max-width: 140px !important;
    max-height: 40px !important;
  }
  .apostar-banner {
    width: 100% !important;
    max-width: 100% !important;
    padding: 8px 10px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  .logos-banner {
    width: 100% !important;
    max-width: 100% !important;
    padding: 8px 10px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    flex-direction: column !important;
  }
  .separador-logos {
    width: 60px !important;
    height: 2px !important;
    margin: 5px 0 !important;
    background: linear-gradient(to right, transparent, #294697, transparent) !important;
  }
  .v-container {
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .v-row {
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
  }
  .v-col {
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}

@media (max-width: 480px) {
  .login-card-responsive {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 5px auto !important;
    box-sizing: border-box !important;
  }
  .bienvenido-nova {
    font-size: 1.3rem !important;
    padding: 8px 5px !important;
    letter-spacing: 1px;
    width: 100% !important;
    max-width: 95vw !important;
    box-sizing: border-box !important;
  }
  .logo-apostar {
    max-width: 120px !important;
    max-height: 35px !important;
  }
  .logo-facilisimo {
    max-width: 120px !important;
    max-height: 35px !important;
  }
  .apostar-banner {
    width: 100% !important;
    max-width: 100% !important;
    padding: 5px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  .logos-banner {
    width: 100% !important;
    max-width: 100% !important;
    padding: 5px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    flex-direction: column !important;
  }
  .separador-logos {
    width: 50px !important;
    height: 2px !important;
    margin: 3px 0 !important;
    background: linear-gradient(to right, transparent, #294697, transparent) !important;
  }
}

/* Global styles para login responsive */
* {
  box-sizing: border-box;
}

html, body {
  overflow-x: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 100vw !important;
  max-width: 100vw !important;
}

.v-application {
  overflow-x: hidden !important;
  width: 100vw !important;
  max-width: 100vw !important;
}

.v-application--wrap {
  overflow-x: hidden !important;
  width: 100vw !important;
  max-width: 100vw !important;
}
</style>